import { ReviewsContainer } from '@/modules/Reviews';

export const Reviews = (): JSX.Element => <ReviewsContainer />;

export default Reviews;
